import { AccountCreationScreen } from '@/components/AccountCreationScreen';

export default function AccountCreation() {
  return <AccountCreationScreen />;
}
